
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Icon from 'components/Icon'
import VectorImage from 'components/VectorImage'

export default class SlideContainer extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    onCloseModal: PropTypes.func,
    icon: PropTypes.object
  }

  static defaultProps = {
    type: 'from-right',
    width: 530
  }

  render() {
    const {type, className, width} = this.props
    const classNames = classnames('slide-container', className, {
      [`slide-container_${type}`]: type
    })
    const styles = {
      maxWidth: 'calc(100vw - 200px)',
      width
    }
    return (
      <div className={classNames} onClick={this.onClick}>
        <div className='slide-container_body' style={styles}>
          {this.renderHeader()}
          {this.renderSubtitle()}
          {this.renderBody()}
        </div>
      </div>
    )
  }

  renderHeader() {
    const {title, onCloseModal} = this.props
    if (!title) return null

    return (
      <div className='slide-container_header'>
        {this.renderIcon()}
        <div className='slide-container_header_title'>{title}</div>
        <Icon
          className='slide-container_close-icon'
          name='cross'
          size='25px'
          onClick={onCloseModal}
        />
      </div>
    )
  }

  renderSubtitle() {
    const {subtitle} = this.props
    if (!subtitle) return null

    return (
      <div className='slide-container_subtitle'>{subtitle}</div>
    )
  }

  renderBody() {
    const {children, className} = this.props
    const classNames = classnames('slide-container_content', `${className}_content`)

    return (
      <div className={classNames}>{children}</div>
    )
  }

  renderIcon() {
    const {icon, className} = this.props
    if (!icon) return null

    const classNames = classnames('slide-container_image_icon', `${className}_icon`)

    return (
      <div className='slide-container_image'>
        <VectorImage
          className={classNames}
          source={icon}
        />
      </div>
    )
  }

  onClick = e => {
    e.stopPropagation()
  }
}



// WEBPACK FOOTER //
// ./client/components/SlideContainer/index.js